/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllCommentsTabCommentContainerLocal = {
    readonly refreshStream: boolean | null;
    readonly " $refType": "AllCommentsTabCommentContainerLocal";
};
export type AllCommentsTabCommentContainerLocal$data = AllCommentsTabCommentContainerLocal;
export type AllCommentsTabCommentContainerLocal$key = {
    readonly " $data"?: AllCommentsTabCommentContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabCommentContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshStream",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '89e04de5a307bcfc970ac228cd5e5def';
export default node;
